import { onMounted, ref } from 'vue';
import api from '@/http/axios';
import { isNativeCognitoEnabled } from './cognitoFeatureFlag';

/** Legacy forms keep their current path; native forms wait for the backend recovery gate. */
export function usePasswordRecovery(needsCoordinator = isNativeCognitoEnabled) {
  const available = ref(!needsCoordinator);
  onMounted(async () => {
    if (!needsCoordinator) return;
    try {
      const response = await api.get('/v3/auth/recovery-config', { timeout: 3000 });
      available.value = response.data?.enabled === true;
    } catch {
      available.value = false;
    }
  });
  return available;
}
